import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiMonitoringsIdService(id) {
  return fetch(`monitorings/${id}`, {
    method: 'GET',
    ms: 'MONITORING',
    auth: true,
  });
}
